<template>
  <div
    style="
      display: flex;
      margin-top: 1em;
      margin-right: 1em;
      justify-content: space-between;
    "
  >
    <div v-if="showBackButton">
      <button
        @click="goBack"
        class="back-button"
        style="margin-left: 1em; background-color: white; border: none"
      >
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14 26L15.41 24.59L7.83002 17H28V15H7.83002L15.41 7.41L14 6L4 16L14 26Z"
            fill="#1B4965"
          />
        </svg>
      </button>
    </div>
    <div v-else>
      <p
        style="
          font-size: 20px;
          font-weight: 600;
          text-align: left;
          color: #2f6787;
          margin-bottom: 0;
          margin-left: 1em;
        "
      >
        {{ pageTitle }}
      </p>
    </div>
    <button
      data-bs-toggle="offcanvas"
      data-bs-target="#offcanvasRight"
      aria-controls="offcanvasRight"
      style="border: none; background-color: #ffffff00"
    >
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M28 22H4V24H28V22Z" fill="#1B4965" />
        <path d="M28 15H10V17H28V15Z" fill="#1B4965" />
        <path d="M28 7.98999H4V9.98999H28V7.98999Z" fill="#1B4965" />
      </svg>
    </button>
  </div>

  <div
    class="offcanvas offcanvas-end"
    tabindex="-1"
    id="offcanvasRight"
    aria-labelledby="offcanvasRightLabel"
    style="width: 80%"
  >
    <div class="offcanvas-header">
      <div>
        <p id="offcanvasRightLabel" style="font-size: 14px; margin: 0">
          Olá, amigo(a) de
        </p>
        <p
          id="offcanvasRightLabel"
          style="
            font-size: 16px;
            font-weight: 600;
            margin: 0;
            color: #2f6787;
            text-align: left;
          "
        >
          São Lourenço
        </p>
      </div>
      <button
        type="button"
        class="btn-close text-reset"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      ></button>
    </div>
    <div class="offcanvas-body">
      <ul class="navbar-nav line-items">
        <a href="/" class="nav-link" style="text-decoration: none">
          <li
            class="nav-item top-border"
            style="display: flex; align-items: center"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.61 2.20999C16.25 1.91999 15.73 1.91999 15.37 2.20999L1 13.42L2.23999 14.99L4 13.62V26C4 27.1 4.9 28 6 28H26C27.1 28 28 27.1 28 26V13.63L29.76 15L31 13.43L16.61 2.21999V2.20999ZM18 26H14V18H18V26ZM20 26V18C20 16.9 19.1 16 18 16H14C12.9 16 12 16.9 12 18V26H6V12.06L16 4.26999L26 12.07V26H20Z"
                fill="#5FA8D3"
              />
            </svg>
            <p
              style="margin-left: 0.8em; font-size: 14px; margin-bottom: 0px;"
              >Início</p
            >

            <svg
              width="8"
              height="14"
              viewBox="0 0 8 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style="margin-left: auto"
            >
              <path
                d="M0.788086 1L6.78809 7L0.788086 13"
                stroke="#4BB1FA"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          </li>
        </a>
        <a href="/attractions" class="nav-link" style="text-decoration: none">
          <li
            class="nav-item top-border"
            style="display: flex; align-items: center"
          >
            <svg
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20.4426 4.9425C20.1576 4.6575 19.7826 4.5 19.3851 4.5H13.2576V1.5H11.7576V9H5.63014C5.23264 9 4.85014 9.1575 4.57264 9.4425L2.01514 12L4.57264 14.5575C4.85764 14.8425 5.23264 15 5.63014 15H11.7576V22.5H13.2576V10.5H19.3851C19.7826 10.5 20.1651 10.3425 20.4426 10.0575L23.0001 7.5L20.4426 4.9425ZM5.62263 13.5L4.12263 12L5.62263 10.5H11.7501V13.5H5.62263ZM19.3776 9H13.2501V6H19.3776L20.8776 7.5L19.3776 9Z"
                fill="#5FA8D3"
              />
            </svg>
            <p
              style="margin-left: 0.8em; font-size: 14px; margin-bottom: 0px;"
              >Turismo</p
            >

            <svg
              width="8"
              height="14"
              viewBox="0 0 8 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style="margin-left: auto"
            >
              <path
                d="M0.788086 1L6.78809 7L0.788086 13"
                stroke="#4BB1FA"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          </li>
        </a>
        <a href="/food" class="nav-link" style="text-decoration: none">
          <li class="nav-item" style="display: flex; align-items: center">
            <svg
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 8.25C18 6.555 17.055 5.0775 15.6675 4.3125C16.1775 3.7725 16.5 3.0525 16.5 2.25H15C15 3.075 14.325 3.75 13.5 3.75C11.0475 3.75 9.04501 5.72249 9.00751 8.16749C8.04751 7.19249 7.5 5.8725 7.5 4.5C7.5 3.1275 6.54 1.94249 5.25 1.60499V0H3.75V1.60499C2.46 1.94249 1.5 3.105 1.5 4.5V8.25H0V9C0 14.79 4.71 19.5 10.5 19.5C16.29 19.5 21 14.79 21 9V8.25H18ZM13.5 5.25C15.1575 5.25 16.5 6.5925 16.5 8.25H10.5C10.5 6.5925 11.8425 5.25 13.5 5.25ZM3 4.5C3 3.675 3.675 3 4.5 3C5.325 3 6 3.675 6 4.5C6 5.85 6.41252 7.1475 7.14752 8.25H3V4.5ZM10.5 18C5.79 18 1.91253 14.3625 1.53003 9.75H19.47C19.0875 14.3625 15.21 18 10.5 18Z"
                fill="#5FA8D3"
              />
            </svg>
            <p
              style="margin-left: 0.8em; font-size: 14px; margin-bottom: 0px;"
              >Gastronomia</p
            >

            <svg
              width="8"
              height="14"
              viewBox="0 0 8 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style="margin-left: auto"
            >
              <path
                d="M0.788086 1L6.78809 7L0.788086 13"
                stroke="#4BB1FA"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          </li>
        </a>
        <a href="/events" class="nav-link" style="text-decoration: none">
          <li class="nav-item" style="display: flex; align-items: center">
            <svg
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.2573 10.5C22.6698 10.5 23.0073 10.1625 23.0073 9.75V6C23.0073 5.175 22.3323 4.5 21.5073 4.5H3.50732C2.68232 4.5 2.00732 5.175 2.00732 6V9.75C2.00732 10.1625 2.34482 10.5 2.75732 10.5C3.58232 10.5 4.25732 11.175 4.25732 12C4.25732 12.825 3.58232 13.5 2.75732 13.5C2.34482 13.5 2.00732 13.8375 2.00732 14.25V18C2.00732 18.825 2.68232 19.5 3.50732 19.5H21.5073C22.3323 19.5 23.0073 18.825 23.0073 18V14.25C23.0073 13.8375 22.6698 13.5 22.2573 13.5C21.4323 13.5 20.7573 12.825 20.7573 12C20.7573 11.175 21.4323 10.5 22.2573 10.5ZM21.5073 14.9025V18H16.2573V15.75H14.7573V18H3.50732V14.9025C4.79732 14.5725 5.75732 13.395 5.75732 12C5.75732 10.605 4.79732 9.4275 3.50732 9.0975V6H14.7573V8.25H16.2573V6H21.5073V9.0975C20.2173 9.435 19.2573 10.605 19.2573 12C19.2573 13.395 20.2173 14.5725 21.5073 14.9025Z"
                fill="#5FA8D3"
              />
            </svg>
            <p
              style="margin-left: 0.8em; font-size: 14px; margin-bottom: 0px;"
              >Eventos</p
            >

            <svg
              width="8"
              height="14"
              viewBox="0 0 8 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style="margin-left: auto"
            >
              <path
                d="M0.788086 1L6.78809 7L0.788086 13"
                stroke="#4BB1FA"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          </li>
        </a>
        <a href="/hotels" class="nav-link" style="text-decoration: none">
          <li class="nav-item" style="display: flex; align-items: center">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.125 11.25C7.7475 11.25 8.25 11.7525 8.25 12.375C8.25 12.9975 7.7475 13.5 7.125 13.5C6.5025 13.5 6 12.9975 6 12.375C6 11.7525 6.5025 11.25 7.125 11.25ZM7.125 9.75C5.6775 9.75 4.5 10.9275 4.5 12.375C4.5 13.8225 5.6775 15 7.125 15C8.5725 15 9.75 13.8225 9.75 12.375C9.75 10.9275 8.5725 9.75 7.125 9.75Z"
                fill="#5FA8D3"
              />
              <path
                d="M18.75 10.5H12.75C11.925 10.5 11.25 11.175 11.25 12V16.5H3V7.94999L12 3.10499L21.3975 8.16749L22.11 6.84751L12.36 1.59751C12.1425 1.47751 11.8725 1.47751 11.6475 1.59751L1.89748 6.84751C1.65748 6.97501 1.5 7.22999 1.5 7.50749V22.5075H3V18.0075H21V22.5075H22.5V14.2575C22.5 12.1875 20.82 10.5075 18.75 10.5075V10.5ZM12.75 16.5V12H18.75C19.9875 12 21 13.0125 21 14.25V16.5H12.75Z"
                fill="#5FA8D3"
              />
            </svg>

            <p
            style="margin-left: 0.8em; font-size: 14px; margin-bottom: 0px;"
              >Hospedagem</p
            >

            <svg
              width="8"
              height="14"
              viewBox="0 0 8 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style="margin-left: auto"
            >
              <path
                d="M0.788086 1L6.78809 7L0.788086 13"
                stroke="#4BB1FA"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          </li>
        </a>
        <a href="/services" class="nav-link" style="text-decoration: none">
          <li class="nav-item" style="display: flex; align-items: center">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21.57 8.51248C21.4275 8.34748 21.2175 8.25 21 8.25H16.5V5.25C16.5 4.0125 15.4875 3 14.25 3H9.75004C8.51254 3 7.50004 4.0125 7.50004 5.25V8.25H3.00004C2.78254 8.25 2.57254 8.34748 2.43004 8.51248C2.28754 8.67748 2.22754 8.9025 2.25754 9.1125L3.66004 18.225C3.77254 18.96 4.39504 19.5 5.14504 19.5H18.855C19.5975 19.5 20.2275 18.9675 20.34 18.225L21.7425 9.1125C21.7725 8.895 21.7125 8.67748 21.57 8.51248ZM9.00004 5.25C9.00004 4.8375 9.33753 4.5 9.75004 4.5H14.25C14.6625 4.5 15 4.8375 15 5.25V8.25H9.00004V5.25ZM18.855 18H5.14504L3.87753 9.75H20.13L18.8625 18H18.855Z"
                fill="#5FA8D3"
              />
            </svg>
            <p
            style="margin-left: 0.8em; font-size: 14px; margin-bottom: 0px;"
              >Compras</p
            >

            <svg
              width="8"
              height="14"
              viewBox="0 0 8 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style="margin-left: auto"
            >
              <path
                d="M0.788086 1L6.78809 7L0.788086 13"
                stroke="#4BB1FA"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          </li>
        </a>
        <a href="/about" class="nav-link" style="text-decoration: none">
          <li class="nav-item" style="display: flex; align-items: center">
            <svg
              width="20"
              height="20"
              viewBox="0 0 27 27"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M23.0101 26.01H22.8401C3.19011 24.88 0.400089 8.29999 0.0100894 3.23999C-0.119911 1.58999 1.1201 0.15002 2.7701 0.0200195C2.8501 0.0200195 2.93009 0.0200195 3.01009 0.0200195H8.28011C9.10011 0.0200195 9.84009 0.520029 10.1401 1.28003L11.6601 5.02002C11.9601 5.76002 11.79 6.61005 11.22 7.18005L9.09011 9.32996C9.77011 13.2 12.8001 16.2401 16.6701 16.9301L18.8401 14.78C19.4201 14.22 20.2701 14.06 21.0101 14.37L24.7801 15.88C25.5301 16.19 26.0201 16.93 26.0101 17.74V23.02C26.0101 24.68 24.6701 26.02 23.0101 26.02V26.01ZM3.01009 2.01001C2.46009 2.01001 2.01009 2.45001 2.01009 3.01001C2.01009 3.04001 2.01009 3.06997 2.01009 3.08997C2.47009 9.00997 5.42009 23.01 22.9501 24.01C23.5001 24.04 23.9801 23.6199 24.0101 23.0699C24.0101 23.0499 24.0101 23.03 24.0101 23.01V17.73L20.2401 16.22L17.3701 19.0699L16.8901 19.01C8.19009 17.92 7.01009 9.22001 7.01009 9.13L6.95009 8.65002L9.79006 5.78003L8.29006 2.01001H3.01009Z"
                fill="#5FA8D3"
              />
            </svg>
            <p
            style="margin-left: 0.8em; font-size: 14px; margin-bottom: 0px;"
              >Contato</p
            >

            <svg
              width="8"
              height="14"
              viewBox="0 0 8 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style="margin-left: auto"
            >
              <path
                d="M0.788086 1L6.78809 7L0.788086 13"
                stroke="#4BB1FA"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          </li>
        </a>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: ["showBackButton", "pageTitle"],
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style>
.line-items li {
  border-bottom: 1px solid rgb(124, 135, 143, 0.2); /* Add a border to the bottom of each list item */
  padding-bottom: 10px; /* Adjust as needed */
  margin-bottom: 10px; /* Adjust as needed */
  /* Optional: Set margin and padding to control spacing between list items */
}
</style>
